import { RowFinancialInstitutionDto } from "@/dtos";
import { FinancialInstitution } from "@/entities";
import { getFinancialInstitutionTypeLabel } from "@/helpers/options";

export const formatRowFinancialInstitutionDto = (financialInstitutions: FinancialInstitution[]): RowFinancialInstitutionDto[] => {
    return financialInstitutions.map(x => {
        const row: RowFinancialInstitutionDto = {
            ...x,
            active: x.is_active ? 'Activo' : 'Inactivo',
            type_label: getFinancialInstitutionTypeLabel(x.type)
        }

        return row;
    });
}